// extracted by mini-css-extract-plugin
export var selectLabel = "SelectSection-module--selectLabel--a1a60";
export var selectSection = "SelectSection-module--selectSection--b5250";